<template>
  <section class="search-query">
    <label>{{ label }}</label>
    <b-button size="sm" v-if="!isCopyToClipboard" class="but-copy" v-on:click="setToClipboard">
      Копировать
    </b-button>
    <b-card class="search-card">
      <b-textarea v-model="clipboardText" v-if="isCopyToClipboard" ref="clipboardRef"></b-textarea>
      <b-container fluid v-if="!isCopyToClipboard">
        <b-row v-for="(tag, index) in tagList" v-bind:key="index">
          <b-col class="search-name-box">
            <b-container fluid>
              <b-row>
                <b-col cols="4" class="text-left">
                  <i
                      v-if="isEditTags[index] === undefined || !isEditTags[index]"
                      v-on:click="editTags(index)"
                  >{{ tag.query }}</i>
                  <b-input
                      v-model="tag.query"
                      v-show="isEditTags[index] !== undefined && isEditTags[index]"
                      v-on:change="editTags(index, true)"
                      :ref="'editTags_'+ index"
                      size="sm"
                      class="mb-1"
                      v-if="tagList[index] !== undefined"
                      v-on:focusout="handleFocusout(index)"
                  ></b-input>
                </b-col>
                <b-col cols="1">
                  <i
                      v-if="isEditTags[index] === undefined || !isEditTags[index]"
                      v-on:click="editTags(index)"
                  >{{ tag.languages }}</i>
                  <b-input
                      v-model="tag.languages"
                      v-show="isEditTags[index] !== undefined && isEditTags[index]"
                      v-on:change="editTags(index, true)"
                      :ref="'editTagsLang_'+ index"
                      size="sm"
                      class="mb-1"
                      v-if="tagList[index] !== undefined"
                      v-on:focusout="handleFocusout(index)"
                  ></b-input>
                </b-col>
                <b-col cols="6"></b-col>
                <b-col cols="1">
                  <button type="button" class="but-remove close b-form-tag-remove ml-1"
                          v-on:click="queryDelete(index)">×
                  </button>
                </b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
        <b-row align-h="center" class="mt-2 ml-2 mr-1">
          <b-col cols="7">
            <b-textarea
                size="sm"
                class="mb-2 query-input"
                rows="1"
                v-model="newTags"
            >
            </b-textarea>
          </b-col>
          <b-col>
            <multiselect
                v-model="selectedLanguages"
                :options="languages"
                label="name"
                track-by="id"
                :multiple="true"
                open-direction="top"
                :close-on-select="false"
                :show-labels="false"
                :clear-on-select="false"
                :searchable="true"
                size="sm"
            ></multiselect>
          </b-col>
          <b-col cols="1">
          </b-col>
          <b-col>
            <button @click="addNewQuery" type="button" class="btn btn-outline-secondary float-right">добавить</button>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </section>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: "Tags",
  props: {
    tagList: Array,
    label: String,
    change: Function,
    languages: Array
  },
  components: {
    Multiselect,
  },
  data() {
    return {
      isEditTags: {},
      newTags: null,
      clipboardText: '',
      isCopyToClipboard: false,
      selectedLanguages: [],
    }
  },
  methods: {
    getMaxKey: function (object) {
      let maxKey = -1;
      for (let key in object) {
        if (parseInt(key) > maxKey) {
          maxKey = key;
        }
      }
      return maxKey;
    },
    addNewQuery: function () {
      let maxKey = this.getMaxKey(this.tagList);
      maxKey++;
      let newKey = maxKey;
      let tagsSplit = this.newTags.split("\n");
      tagsLoop:
      for (let ind in tagsSplit) {
        let langCodes = 'ww'
        if (this.selectedLanguages.length <= 2) {
          let languages = this.selectedLanguages.map(lang => lang.code)
          langCodes = languages.toString()
        }

        for (let key in this.tagList) {
          if (this.tagList[key].query === tagsSplit[ind]) {
            let newLangCodes = this.tagList[key].languages + ',' + langCodes
            if (newLangCodes.includes('ww') || newLangCodes.split(',').length > 2) {
              newLangCodes = 'ww'
            }
            this.tagList[key].languages = newLangCodes
            continue tagsLoop;
          }
        }
        // if (!this.tagList.includes(tagsSplit[query])) {
        //   this.tagList.push(tagsSplit[query])
        // }
        this.$set(this.tagList, newKey, {
          id: newKey,
          query: tagsSplit[ind],
          isNew: true,
          languages: langCodes
        });
        newKey++;
      }
      this.newTags = null;
      this.change();
    },
    editTags: function (index, isStop = false) {
      for (let key in this.isEditTags) {
        const isWW = this.tagList[index]['languages'].includes('ww') || this.tagList[index]['languages'].split(',').length > 2
        if(isWW) {
          this.tagList[index]['languages'] = 'ww'
        }
        this.$set(this.isEditTags, key, false);
      }

      this.$set(this.isEditTags, index, !isStop);
      // remove if it is duplicate
      for (let key in this.tagList) {
        if (this.tagList[index] == this.tagList[key] && index != key) {
          this.tagList.splice(index, 1)
        }
      }
      this.$nextTick(() => {
        if (isStop) {
          this.change();
        }
        // this.$refs['editTags_' + index][0].focus();
      });
    },
    queryDelete: async function (index) {
      this.tagList.splice(index, 1)
      this.$forceUpdate()
      this.change();
    },
    setToClipboard: async function () {
      this.clipboardText = '';
      this.isCopyToClipboard = true;
      await this.$nextTick();
      this.clipboardText = this.tagList.join("\n")
      await this.$nextTick();
      let textareaEl = this.$refs.clipboardRef.$el;
      textareaEl.select();
      textareaEl.setSelectionRange(0, 99999);
      try {
       document.execCommand('copy');
      } catch (err) {
        alert('Oops, unable to copy');
      }
      /* unselect the range */
      window.getSelection().removeAllRanges();
      this.isCopyToClipboard = false;
    },
    handleFocusout: function (index) {
      this.$refs['editTags_' + index][0].focus();
    },
  },
  mounted() {
  }
}
</script>

<style scoped>
.search-link-box.col-4 {
  flex: 0 0 30%;
  max-width: 30%;
}

.search-name-box.col-8 {
  flex: 0 0 70%;
  max-width: 70%;
}

.search-query button.but-remove:focus {
  outline: none;
}

.search-query .query-input {
  height: 34px;
  width: 91%;
  margin-right: 5px;
  display: inline-block;
}

.but-add-tags {
  line-height: 34px;
}

.box-but-copy {
  text-align: right;
  margin-top: -8px;
  padding-right: 2px;
  margin-right: -9px;
  margin-bottom: 13px;
  position: sticky;
  top: 10px;
  z-index: 999;
  background: white;
  padding-top: 0;
  padding-bottom: 10px;
  border-bottom: 2px solid;
}

.but-copy {
  float: right;
  margin-bottom: 5px;
}

label {
  text-align: left;
  margin: 0;
  float: left;
}

.search-card {
  width: 100%;
  /*max-height: 370px;*/
  /*overflow-y: auto;*/
}

.duplicate-label {
  margin-left: 32px;
  color: grey;
}
</style>